export default {
    namespaced: true,
    state: {
        clickToEditOrderLineOverview: false,
    },
    mutations: {
        setClickToEditOrderLineOverview(state, value) {
            state.clickToEditOrderLineOverview = value;
        },
    },
    getters: {
        getClickToEditOrderLineOverview(state) {
            return state.clickToEditOrderLineOverview;
        },
    },
};
